module.exports = __webpack_public_path__ + "img/img2.46edc34a.jpeg";